// components/StaticLocationMap.js
import React from 'react';

const StaticLocationMap = ({ 
  latitude, 
  longitude, 
  height = '300px',
  width = '100%',
  zoom = 15
}) => {
  if (!latitude || !longitude) {
    return (
      <div style={{ 
        height, 
        width,
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        borderRadius: '4px'
      }}>
        <div style={{ textAlign: 'center', color: '#666' }}>
          <div style={{ fontSize: '48px', marginBottom: '8px' }}>📍</div>
          <div>الموقع غير متاح</div>
        </div>
      </div>
    );
  }

  const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?
    center=${latitude},${longitude}
    &zoom=${zoom}
    &size=600x300
    &markers=color:red%7C${latitude},${longitude}
    &key=${process.env.REACT_APP_MAP_API_KEY}`;

  return (
    <div style={{ position: 'relative', width, height }}>
      <img 
        src={staticMapUrl} 
        alt="Order location" 
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'cover',
          borderRadius: '4px',
          border: '1px solid #ddd'
        }}
      />
      <div style={{
        position: 'absolute',
        bottom: '8px',
        left: '8px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        color: '#333'
      }}>
        📍 {latitude}, {longitude}
      </div>
    </div>
  );
};

export default StaticLocationMap;